import AntdModal from 'antd/lib/modal';
import React from 'react';

interface Props {
  title?: string;
  cancelText?: string;
  okText?: string;
  visible: boolean;
  okButtonDisabled?: boolean;
  okButtonLoading?: boolean;
  onCancel?: () => void;
  onOk?: () => void;
}

const Modal: React.FC<Props> = ({
  visible,
  cancelText,
  okText,
  title,
  onOk,
  okButtonDisabled,
  okButtonLoading,
  onCancel,
  children
}) => {
  if (!visible) {
    return null;
  }

  return (
    <AntdModal
      visible={visible}
      onCancel={onCancel}
      onOk={onOk}
      cancelText={cancelText}
      okText={okText}
      title={title}
      cancelButtonProps={{}}
      okButtonProps={{ disabled: okButtonDisabled, loading: okButtonLoading }}
    >
      {children}
    </AntdModal>
  );
};

export { Modal };
